export default __webpack_public_path__ + "static/media/banner-12h-mobile.837b4477.jpg";